import { IDspDealByCampaignId } from "campaign/model"
import {
  ICreateDspDealParams,
  IDspDeal,
  IDspDealAdvertiserDomain,
  IDspDealAssociations,
  IDspDealFormat,
  IDspDealSeat,
  IUpdateDspDealParams
} from "dsp-deal/model"
import { dspDealRPO } from "dsp-deal/repository"

export const getAllDealDsp = (): Promise<IDspDeal[]> => dspDealRPO.getAllDspDeal()

export const getDspDealsByCampaignId = async (campaignIds: number[]): Promise<IDspDeal[]> =>
  dspDealRPO.getAllDspDeal(campaignIds)

export const getDealIdAssociations = async (dealId: number): Promise<IDspDealAssociations> => {
  const result: IDspDealAssociations = {
    advertiserDomains: [],
    formats: [],
    seats: []
  }
  const promises = [
    dspDealRPO
      .getDspDealAdvertiserDomains(dealId)
      .then(advertiserDomains => (result.advertiserDomains = advertiserDomains)),
    dspDealRPO.getDspDealFormats(dealId).then(formats => (result.formats = formats)),
    dspDealRPO.getDspDealSeats(dealId).then(seats => (result.seats = seats))
  ]
  await Promise.allSettled(promises)
  return result
}

export const getDspDealByCampaignId = async (campaignIds: number[]): Promise<IDspDealByCampaignId> => {
  const result: IDspDealByCampaignId = {}
  const dspDeals = await getDspDealsByCampaignId(campaignIds)
  for (const dspDeal of dspDeals) {
    result[dspDeal.campaign_id] = dspDeal
  }
  return result
}

export const createDspDeal = (params: ICreateDspDealParams): Promise<IDspDeal> => {
  if (!params || typeof params !== "object") {
    throw Error("Missing params")
  }
  if (typeof params.dsp_id !== "number") {
    throw Error("Missing dsp_id param")
  }
  if (typeof params.campaign_id !== "number") {
    throw Error("Missing campaign_id param")
  }
  if (params.auction_type !== undefined && typeof params.auction_type !== "number") {
    throw Error("Invalid auction_type param")
  }
  if (params.bid_floor !== undefined && typeof params.bid_floor !== "number") {
    throw Error("Invalid bid_floor param")
  }
  if (params.dealid !== undefined && typeof params.dealid !== "string") {
    throw Error("Invalid dealid param")
  }
  if (params.description !== undefined) {
    if (typeof params.description !== "string") {
      throw Error("Invalid description param, not a string")
    } else if (params.description.length > 255) {
      throw Error("Invalid description param, must be lower or equals to 255")
    }
  }
  return dspDealRPO.createDspDeal(params)
}

export const updateDspDeal = (dspDeal: IUpdateDspDealParams): Promise<IDspDeal> => {
  return dspDealRPO.updateDspDeal(dspDeal)
}

export const setDspDealAdvertiserDomains = (
  dealId: number,
  advertiserIds: number[]
): Promise<IDspDealAdvertiserDomain[]> => {
  return dspDealRPO.setDspDealAdvertiserDomains(dealId, advertiserIds)
}

export const setDspDealFormats = (dealId: number, formatIds: number[]): Promise<IDspDealFormat[]> => {
  return dspDealRPO.setDspDealFormats(dealId, formatIds)
}

export const setDspDealSeats = (dealId: number, seatIds: number[]): Promise<IDspDealSeat[]> => {
  return dspDealRPO.setDspDealSeats(dealId, seatIds)
}

export const getDspDealAdvertiserDomains = (dealId: number): Promise<IDspDealAdvertiserDomain[]> => {
  return dspDealRPO.getDspDealAdvertiserDomains(dealId)
}

export const getDspDealFormats = (dealId: number): Promise<IDspDealFormat[]> => {
  return dspDealRPO.getDspDealFormats(dealId)
}

export const getDspDealSeats = (dealId: number): Promise<IDspDealSeat[]> => {
  return dspDealRPO.getDspDealSeats(dealId)
}
